class Tabs {
  constructor(element) {
    this.element = element;
    this.move = 0;
    this.showArrows = false;
    this.tabsWrapperLeftEdge = 0;
    this.tabsWrapperRightEdge = 0;
    this.leftArrowDisabled = true;
    this.rightArrowDisabled = false;

    // Get DOM references
    this.tabsListNode = this.element.querySelector('[role="tablist"]');
    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tabsListNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    
    this.$tabsWrapper = $(this.element).find(".tab-header");
    this.$arrows = $(this.element).find("[data-tab-controls]");

    // Bind methods that are used as event callbacks so "this" stays the instance
    this.initiateTabs = this.initiateTabs.bind(this);
    this.moveTabsLeft = this.moveTabsLeft.bind(this);
    this.moveTabsRight = this.moveTabsRight.bind(this);

    this.init();
  }

  init() {
    setTimeout(() => {
      this.initiateTabs(); // performs initial arrow check + bounding box
    });

    // In case this block is put inside accordion block
    const $closestAccordionParent = $(this.element).closest('.accordion');
    if ($closestAccordionParent.length) {
      window.addEventListener('collapseClicked', () => {
        if ($closestAccordionParent.hasClass('open')) {
          this.initiateTabs();
        }
      });
    }

    this.$arrows.find('[data-tab-left]').on('click', this.moveTabsLeft);
    this.$arrows.find('[data-tab-right]').on('click', this.moveTabsRight);

    // Use bound method to retain instance context
    window.addEventListener('resize', this.initiateTabs);
    window.addEventListener('collapseClicked', this.initiateTabs);
  }

  initiateTabs() {
    this.checkIfArrowsShouldShow();
    this.setTabsWrapperBoundingBox();
  }

  checkIfArrowsShouldShow() {
    const headerEl = this.element.querySelector(".tab-header");
    if (!headerEl || !this.tabsListNode) return;

    // Show arrows if tab list width exceeds the visible header width
    this.showArrows = this.tabsListNode.offsetWidth > headerEl.offsetWidth;
    if (this.showArrows) {
      // Reset positioning state
      this.move = 0;
      this.tabsListNode.style.left = "0px";
      this.leftArrowDisabled = true;
      this.$arrows.find('[data-tab-left]').attr('disabled', true);
      this.rightArrowDisabled = false;
      this.$arrows.find('[data-tab-right]').attr('disabled', null);
      this.$arrows.attr("hidden", null);
    }
    else {
      this.$arrows.attr("hidden", true);
    }
  }

  setTabsWrapperBoundingBox() {
    this.tabsWrapperLeftEdge = this.$tabsWrapper.offset().left;
    this.tabsWrapperRightEdge = this.tabsWrapperLeftEdge + this.$tabsWrapper.outerWidth();
  }

  moveTabsLeft() {
    if (!this.showArrows) return;
    this.setTabsWrapperBoundingBox();

    this.$tabsWrapper.find('li').each((index, item) => {
      const $li = $(item);
      const liLeft = $li.offset().left;
      const liRight = liLeft + $li.outerWidth();

      // Find first partially hidden item on the left
      if (liLeft < this.tabsWrapperLeftEdge && liRight + 2 > this.tabsWrapperLeftEdge) {
        this.move += this.tabsWrapperLeftEdge - liLeft;
        this.tabsListNode.style.left = this.move + "px";
        this.rightArrowDisabled = false;
        this.$arrows.find('[data-tab-right]').attr('disabled', null);
        this.leftArrowDisabled = index === 0;
        this.$arrows.find('[data-tab-left]').attr('disabled', this.leftArrowDisabled ? true : null);
        return false;
      }
    });
  }

  moveTabsRight() {
    if (!this.showArrows) return;
    this.setTabsWrapperBoundingBox();

    const $listItems = this.$tabsWrapper.find('li');
    $listItems.each((index, item) => {
      const $li = $(item);
      const liLeft = $li.offset().left;
      const liRight = liLeft + $li.outerWidth();

      // Find first item overflowing on the right
      if (liRight - 2 > this.tabsWrapperRightEdge) {
        this.move -= liRight - this.tabsWrapperRightEdge;
        this.tabsListNode.style.left = this.move + "px";
        this.leftArrowDisabled = false;
        this.$arrows.find('[data-tab-left]').attr('disabled', null);
        this.rightArrowDisabled = index === $listItems.length - 1;
        this.$arrows.find('[data-tab-right]').attr('disabled', this.rightArrowDisabled ? true : null);
        return false;
      }
    });
  }

  setSelectedTab(currentTab) {
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        tab.removeAttribute('tabindex');
        // check if the tab is fully visible, if not move the tabs and update arrow states
        const tabLeft = tab.offsetLeft + this.move;
        const tabRight = tabLeft + tab.offsetWidth;
        if (tabLeft < 0) {
          this.move += -tabLeft;
          this.tabsListNode.style.left = this.move + "px";
          this.leftArrowDisabled = this.move === 0;
          this.$arrows.find('[data-tab-left]').attr('disabled', this.leftArrowDisabled ? true : null);
          this.rightArrowDisabled = false;
          this.$arrows.find('[data-tab-right]').attr('disabled', null);
        } else if (tabRight > this.$tabsWrapper.outerWidth()) {
          this.move -= tabRight - this.$tabsWrapper.outerWidth();
          this.tabsListNode.style.left = this.move + "px";
          this.rightArrowDisabled = currentTab === this.lastTab;
          this.$arrows.find('[data-tab-right]').attr('disabled', this.rightArrowDisabled ? true : null);
          this.leftArrowDisabled = false;
          this.$arrows.find('[data-tab-left]').attr('disabled', null);
        }
        this.tabpanels[i].removeAttribute('hidden');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.classList.remove('active');
        tab.tabIndex = -1;
        this.tabpanels[i].setAttribute('hidden', true);
      }
    }
  }

  moveFocusToTab(currentTab) {
    currentTab.focus();
  }

  moveFocusToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.moveFocusToTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index - 1]);
    }
  }

  moveFocusToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.moveFocusToTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index + 1]);
    }
  }

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.moveFocusToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.moveFocusToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.moveFocusToTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.moveFocusToTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

// Initialize all tab areas on the page
const initTabs = () => {
  const TabBlocks = document.querySelectorAll('.js-tab-area');
  TabBlocks.forEach((TabBlock) => new Tabs(TabBlock));
};

// Boot the component when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}